/**
 * Komponenta pro načítání textu na základě klíče z resource textů včetně formátování.
 * Komponenta využívá globální proměnnou messages, která musí být definovaná a musí již představovat aktuálně zvolený jazyk.
 * Pokud daný klíč v messages neexistuje, je vrácen řetězec '[klíč]'.
 * Pokud je vstupem klíč začínající znakem '^', je v případě neexistence klíče vráceno null.
 *
 * Příklad definice messages:
 *     var messages = {
  *         "a.b.c": "Osoba {0}"
  *     };
 *
 * Příklad formátu:
 *     i18n('a.b.c', person.displayName);
 **/

// TODO [stanekpa] - musíme vyřešit načítání jazyků jinak!!!!! - dynamicky a od jinud!
const cs = require("./global-cs.js");
const messages = {
    ...cs,
    ...(typeof window !== 'undefined' && window.messages ? window.messages : {}),
};

if (typeof window !== 'undefined') {
    window.messages = messages;
}

String.format = function(format) {
  var args = Array.prototype.slice.call(arguments, 1);
  return format.replace(/{(\d+)}/g, function(match, number) {
    return typeof args[number] != 'undefined'
      ? args[number]
      : match
    ;
  });
};

function getForKey(key, resolveNullAsText, ...params) {
    if (key[0] == '^') {
        key = key.substring(1, key.length);
        var text = messages[key];
        return text != null ? String.format(text, ...params) : null;
    } else {
        var text = messages[key];
        if (!text && key.indexOf("[") > 0) {    // pokus o odebr8ní všech polí, např. [3] a sestavení klíče bez nich (form.title.seznamKvalifikaci[0].umysl -> form.title.seznamKvalifikaci.umysl)
            while (true) {
                var i1 = key.indexOf("[");
                var i2 = key.indexOf("]");
                if (i1 >= 0 && i2 > 0 && i1 < i2) {
                    key = key.substring(0, i1) + key.substring(i2 + 1);
                } else {
                    break;
                }
            }
            if (key) {
                text = messages[key];
            }
        }
        if (resolveNullAsText) {
            return text != null ? String.format(text, ...params) : "[" + key + "]";
        } else {
            return text != null ? String.format(text, ...params) : null;
        }
    }
}

export default function i18n(key, ...params) {
    if (key) {
        // Key může být buď string nebo pole, pokud je pole, testují se postupně všechny klíče až se na nějaký narazí
        if (Object.prototype.toString.call(key) === "[object Array]") { // pole
            if (key.length === 0) { // nejsou definovány žádné klíče
                console.error("Resource text keys cannot be empty.");
                return null;
            }

            for (let a=0; a<key.length; a++) {
                const oneKey = key[a];
                const text = getForKey(oneKey, false, params);
                if (text !== null) {    // máme platný klíč
                    return text;
                }
            }

            // Nenašli jsme platný klíč, vrátíme první jako nepřeložený text
            console.warn("Resource text for keys", key, "not found.");
            return getForKey(key[0], true, params);
        } else {
            return getForKey(key, true, params);
        }
        return text;
    } else {
        return "<null>";
    }
}
